/* sidebar */
$(function(){
  $('.sidebar_fixed_mobile').click(function(){
    $('.close_seidebar, .siejunior_sidebar, #shopify-section-siejunior_sidebar .siejunior_overlay').animate({left: '0px'});
  });
  $('.close_seidebar, #shopify-section-siejunior_sidebar .siejunior_overlay').click(function(){
    $('.close_seidebar, .siejunior_sidebar, #shopify-section-siejunior_sidebar .siejunior_overlay').animate({left: '-100%'});
  });
});

/* popup kontak */
$(function(){
  $('.popup_kontak').click(function(e){
    e.preventDefault();
    $('.popup_kontak_content').show()
  });
  $('.popup_kontak_close').click(function(e){
    e.preventDefault();
    $('.popup_kontak_content').hide()
  });
});